import { useContext } from 'react';
import { ConfigContext } from '../../../../../../Contexts/ConfigContext';
import DropDownSingle from '../../../../../../Components/DropDownSingle';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Grid, Paper } from '@mui/material';
import InputConfig from '../../../../../../Components/InputConfig';
import useCommonStyles from '../../../../../../commonStyles';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Box } from '@mui/system';
import { CTA_TYPES } from '../../../../../../core/constants';

const ctaTypes = [CTA_TYPES.SECTION_LVL, CTA_TYPES.VIDEO_LVL];

const CustomVideoMode = ({ keyData }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const videos = rawConfig['videos'] ? rawConfig['videos'] : [];

	const addNewVideoControl = () => {
		if (rawConfig && rawConfig['videos'] && Array.isArray(rawConfig['videos'])) {
			let updatedVideos = [
				...rawConfig['videos'],
				{ sources: [{ src: '', type: 'video/mp4' }], description: '' }
			];
			updateRawConfig({ ...rawConfig, [keyData]: updatedVideos });
		} else {
			alert("Could'nt find videos in rawConfig!");
		}
	};

	const updateVideo = (id, video) => {
		if (rawConfig && rawConfig['videos'] && Array.isArray(rawConfig['videos'])) {
			let updatedVideos = [...rawConfig['videos']];
			updatedVideos[id] = video;
			updateRawConfig({ ...rawConfig, [keyData]: updatedVideos });
		} else {
			alert("Could'nt find videos in rawConfig!");
		}
	};

	const deleteVideo = (idx) => {
		if (rawConfig && rawConfig['videos'] && Array.isArray(rawConfig['videos'])) {
			let updatedVideos = [...rawConfig['videos']];
			updatedVideos = updatedVideos.filter((data, id) => id !== idx);
			updateRawConfig({ ...rawConfig, [keyData]: updatedVideos });
		} else {
			alert("Could'nt find videos in rawConfig!");
		}
	};

	const commonStyleClasses = useCommonStyles();

	return (
		<Box
			sx={{
				margin: '2rem',
				marginTop: '3rem',
				padding: '1rem'
			}}
		>
			<Grid container spacing={2} padding="2rem">
				{videos.map((video, id) => {
					return (
						<Grid item xs={6}>
							<VideoControl
								src={video.sources[0].src}
								description={video.description}
								type={video.sources[0].type}
								id={id}
								updateVideo={updateVideo}
								deleteVideo={deleteVideo}
								key={id}
								videoLvlCtaDetails={video.videoLvlCtaDetails}
								ctaType={video.ctaType}
							/>
						</Grid>
					);
				})}
			</Grid>

			<Box sx={{ marginTop: '3rem', textAlign: 'center' }}>
				<AddCircleOutlineOutlinedIcon
					color="primary"
					fontSize="large"
					className={commonStyleClasses.icon}
					onClick={addNewVideoControl}
					style={{ marginBottom: '2rem' }}
				/>
			</Box>
		</Box>
	);
};

const VideoControl = ({
	src,
	description,
	type,
	id,
	updateVideo,
	deleteVideo,
	videoLvlCtaDetails = {},
	ctaType = ''
}) => {
	const commonStyleClasses = useCommonStyles();

	return (
		<Box className={commonStyleClasses.basicOutlinedBox} style={{ margin: '0rem' }}>
			<Grid container spacing={1}>
				<Grid item xs={6}>
					<InputConfig
						label="Video Source"
						inputType="string"
						containerStyles={{ marginTop: '.5rem' }}
						labelStyles={{ width: '100%' }}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						isObjectEditor={false}
						directValue={src}
						updateDirectValue={(updatedValue) => {
							updateVideo(id, {
								sources: [{ src: updatedValue, type }],
								description,
								videoLvlCtaDetails,
								ctaType
							});
						}}
					/>
				</Grid>
				<Grid item xs={6} style={{ marginTop: '.8rem' }}>
					<DropDownSingle
						label="Video Type"
						list={['video/mp4', 'application/x-mpegURL']}
						isObjectEditor={false}
						directValue={type}
						formControlStyles={{ width: '100%' }}
						updateDirectValue={(updatedValue) => {
							updateVideo(id, {
								sources: [{ src, type: updatedValue }],
								description,
								videoLvlCtaDetails,
								ctaType
							});
						}}
					/>
				</Grid>
				<Grid item xs={6}>
					<InputConfig
						label="Cta Text"
						inputType="string"
						containerStyles={{ marginTop: '.5rem' }}
						labelStyles={{ width: '100%' }}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						isObjectEditor={false}
						directValue={videoLvlCtaDetails.ctaText}
						updateDirectValue={(updatedValue) => {
							updateVideo(id, {
								sources: [{ src, type }],
								description,
								videoLvlCtaDetails: { ...videoLvlCtaDetails, ctaText: updatedValue },
								ctaType
							});
						}}
						editable={ctaType === CTA_TYPES.VIDEO_LVL}
					/>
				</Grid>
				<Grid item xs={6}>
					<InputConfig
						label="Cta Url"
						inputType="string"
						containerStyles={{ marginTop: '.5rem' }}
						labelStyles={{ width: '100%' }}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						isObjectEditor={false}
						directValue={videoLvlCtaDetails.ctaUrl}
						updateDirectValue={(updatedValue) => {
							updateVideo(id, {
								sources: [{ src, type }],
								description,
								videoLvlCtaDetails: { ...videoLvlCtaDetails, ctaUrl: updatedValue },
								ctaType
							});
						}}
						editable={ctaType === CTA_TYPES.VIDEO_LVL}
					/>
				</Grid>
				<Grid item xs={6} style={{ marginTop: '.8rem' }}>
					<DropDownSingle
						label="Cta Type"
						list={ctaTypes}
						isObjectEditor={false}
						directValue={ctaType}
						formControlStyles={{ width: '100%' }}
						forceDeselect={true}
						updateDirectValue={(updatedValue) => {
							updateVideo(id, {
								sources: [{ src, type }],
								description,
								videoLvlCtaDetails,
								ctaType: updatedValue
							});
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<InputConfig
						multiline={true}
						rows={2}
						label="Video Description"
						inputType="string"
						isObjectEditor={false}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						directValue={description || ''}
						updateDirectValue={(updatedValue) => {
							updateVideo(id, {
								sources: [{ src, type }],
								description: updatedValue,
								videoLvlCtaDetails,
								ctaType
							});
						}}
					/>
				</Grid>

				<Grid item xs={6}>
					<DeleteOutlinedIcon
						color="primary"
						onClick={() => deleteVideo(id)}
						className={commonStyleClasses.icon}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};

export default CustomVideoMode;
